import React from "react";
import gif from '../qr_gif.gif';

const QrSplashPage = (props) => {

    return (
        <div className="splash">
            <img src={gif} alt="" style={{width: "100%", height: "100%"}} />
        </div>
    )
}

export default QrSplashPage;